//Install
import React, { Component } from "react";
//Install
import { Row, Col } from "react-bootstrap";
//Install
import YL3158 from "../../../../Media/Image/052.jpg";

//Element
class K820Q1 extends Component {
    //Element
    render() {
        //Element
        const Content = React.createElement(Row, {},
            //Element
            React.createElement(Col, { md: 5 },
                //Element
                React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB f029qa" },
                    //Element
                    React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB q035zf" },
                        //Element
                        "02"
                    ),
                    //Element
                    React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB g371o1" },
                        //Element
                        "Yenilənə Bilən Enerji"
                    ),
                    //Element
                    React.createElement("h2", { className: "S6pt64 C96Q4r pEO064 a527eB tv2821" },
                        //Element
                        "Gələcəyi Gücləndirən, ",
                        //Element
                        React.createElement("br", {}),
                        //Element
                        React.createElement("em", {},
                            //Element
                            "Davamlı "
                        ),
                        //Element
                        React.createElement("br", {}),
                        //Element
                        "Xidmətlər"
                    )
                )
            ),
            //Element
            React.createElement(Col, { md: 7 },
                //Element
                React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB j392d8" },
                    //Element
                    React.createElement("picture", { className: "S6pt64 C96Q4r pEO064 a527eB u3177a" },
                        //Element
                        React.createElement("img", { alt: "Yenilənə Bilən Enerji", title: "Yenilənə Bilən Enerji", src: YL3158, width: "856", height: "auto" })
                    ),
                    //Element
                    React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB a725gw" },
                        //Element
                        React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB y48p90" },
                            //Element
                            "Yenilənə Bilən Enerji, Günəş, Külək, Yağış Və Geotermal İstilik Kimi Təbii Mənbələrdən Əldə Edilən Və Davamlı Olaraq Özünü Təzələyə Bilən Enerji Növüdür. Ətraf Mühitə Uyğun Quruluşu Və Davamlılıq Xüsusiyyəti Ilə Gələcəyin Enerji Tələbatını Qarşılamaqda Əhəmiyyətli Rol Oynayır."
                        ),
                        //Element
                        React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB y48p90" },
                            //Element
                            "Qlobal İqlim Böhranı Nəticəsində Dünyanı Təhlükə Altına Alan Faktorlarla Mübarizə Üçün, Davamlılıq Məqsədləri Əsasında Fasil Yanacaqların Yerinə Yenilənə Bilən Enerji Mənbələrinin İstifadəsi Sürətlə Artırılır."
                        ),
                        //Element
                        React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB y48p90" },
                            //Element
                            "Yenilənə Bilən Enerji Sahəsində Dam, Fasad, Torpaq Və Kənd Təsərrüfatı Tətbiqlərinə Yönəlmiş Günəş Və Külək Enerjisi Stansiyalarının Açar Təslim Quraşdırma Xidmətlərini Təklif Edir."
                        ),
                        //Element
                        React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB y48p90" },
                            //Element
                            "Bununla Birlikdə, Quraşdırma Sonrası Zəmanət, Baxım Və İstismar Xidmətləri Təklif Olunur."
                        )
                    )
                )
            )
        )
        //Element
        return (
            Content
        );
    }
}
//Element
export default K820Q1;